import {Component, OnDestroy, OnInit} from '@angular/core';
import {NavigationService} from "../../../service/navigation-service";
import {environment} from "../../../../environments/environment";

@Component({
    selector: 'app-homepage',
    templateUrl: './homepage.component.html',
    standalone: false
})
export class HomepageComponent implements OnInit, OnDestroy {

  categoriesCards: { src: string, title: string, description: string, padrao: string } []
  openFaq = 0;
  activeFlow = 0;
  socialFacebook = environment.social.facebook;
  socialInstagram = environment.social.instagram;
  socialLinkedIn = environment.social.linkedIn;

  faqs: { question: string, answer: string }[] = [
    {
      question: 'O que é o AngolaEncontra?',
      answer: 'É o sítio para publicar e encontrar pessoas, veículos, documentos e outros bens perdidos ou achados em Angola.'
    },
    {
      question: 'Preciso de conta para procurar?',
      answer: 'Não. A pesquisa é aberta. A conta serve para criar ocorrências, editá-las e gerir pedidos de contacto.'
    },
    {
      question: 'Como crio uma ocorrência?',
      answer: 'Entre na conta, escolha a categoria e descreva o caso: local, data e uma foto. Se quiser, pode indicar uma recompensa.'
    },
    {
      question: 'Porque é que a imagem fica esbatida?',
      answer: 'A foto só fica visível depois de um moderador a validar. Assim o público não vê conteúdo impróprio.'
    },
    {
      question: 'Posso ocultar o meu contacto?',
      answer: 'Sim. Quem quiser falar consigo pede o contacto na plataforma, e você aceita ou recusa no seu painel.'
    },
    {
      question: 'Como encontro uma ocorrência?',
      answer: 'Na lista, filtre por categoria, província e data. Quanto mais preciso for o filtro, menos resultados a mais aparecem.'
    },
    {
      question: 'Posso editar ou fechar uma ocorrência?',
      answer: 'Sim, no detalhe da ocorrência ou em Minhas ocorrências. Se o caso se resolver, feche-o para sair das pesquisas.'
    },
    {
      question: 'E se a ocorrência for falsa?',
      answer: 'Reporte-a. A moderação pode corrigir ou remover. Contas que publiquem abusos podem ser bloqueadas.'
    }
  ];

  flows: { title: string, lead: string, steps: { title: string, text: string }[] }[] = [
    {
      title: 'Quem procura',
      lead: 'A pesquisa é aberta. Não precisa de conta para ver o que já foi publicado.',
      steps: [
        {
          title: 'Procure na lista',
          text: 'Entre nas ocorrências e filtre por categoria, província e data. Quanto mais preciso, menos resultados a mais.'
        },
        {
          title: 'Leia o caso',
          text: 'A descrição e o local estão visíveis. A fotografia só aparece depois de um moderador a validar.'
        },
        {
          title: 'Peça o contacto',
          text: 'Se tiver uma pista, peça o contacto na plataforma. Quem publicou decide se o partilha.'
        }
      ]
    },
    {
      title: 'Quem encontrou',
      lead: 'Publicar é a forma de devolver o que apareceu, sem expor o número a toda a gente.',
      steps: [
        {
          title: 'Crie a ocorrência',
          text: 'Escolha a categoria e indique local, data e uma foto. Pode ser uma pessoa, um documento, um veículo ou outro bem.'
        },
        {
          title: 'Reserve o contacto',
          text: 'O seu contacto fica oculto. Só o vê quem você aceitar, no seu painel.'
        },
        {
          title: 'Feche quando se resolver',
          text: 'Se o caso terminar, encerre a ocorrência. Ela sai das pesquisas e deixa de ocupar a lista.'
        }
      ]
    }
  ];

  constructor(private navigationService: NavigationService) {
  }

  ngOnDestroy(): void {
    this.navigationService.setToLight(true);
  }

  toggleFaq(index: number): void {
    this.openFaq = this.openFaq === index ? -1 : index;
  }

  selectFlow(index: number): void {
    this.activeFlow = index;
  }

  ngOnInit(): void {
    this.navigationService.setToLight(false);

    this.initCategoryCards()
  }

  initCategoryCards() {
    this.categoriesCards = [
      {
        src: 'category-people-v2.png',
        title: 'Pessoas',
        padrao: 'people',
        description: 'Crianças, adultos e idosos. Para quem se perdeu e para quem procura alguém.'
      },
      {
        src: 'category-vehicle-v3.png',
        title: 'Veículos',
        padrao: 'vehicle',
        description: 'Carros, motos, bicicletas e outros transportes, perdidos ou encontrados.'
      },
      {
        src: 'category-document-v2.png',
        title: 'Documentos',
        padrao: 'document',
        description: 'Bilhete de identidade, passaporte, carta de condução e outros papéis.'
      },
      {
        src: 'category-other-v3.png',
        title: 'Diversos',
        padrao: 'other',
        description: 'Chaves, telemóveis, óculos, carteiras e o que não cabe nas outras categorias.'
      }
    ]
  }

}
